/* eslint class-methods-use-this: 0 */
import React from 'react';
import ReactDOM from 'react-dom';
import { DomUtil, Control } from 'leaflet';
import { MapControl, withLeaflet } from 'react-leaflet';
import Icon from 'components/icon';

import './style.css';

class InfoLeafletControl extends Control {
  onAdd() {
    const { onClickInfo } = this.options;

    const jsxTemplate = (
      <div className="c-info-control">
        <button type="button" className="info-button" aria-label="Info" title="Info" onClick={onClickInfo} >
          <Icon className="icon-info" name="icon-info" />
        </button>
      </div>
    );
    const div = DomUtil.create('div', '');
    ReactDOM.render(jsxTemplate, div);
    return div;
  }
}

class InfoControl extends MapControl {
  createLeafletElement(props) {
    return new InfoLeafletControl(props);
  }
}

export default withLeaflet(InfoControl);



// WEBPACK FOOTER //
// ./src/components/map/info-control/index.js